<template>
  <noscript v-if="inOpensaludES"><iframe src="//www.googletagmanager.com/ns.html?id=GTM-KHHSWQZ" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
</template>

<script>
import { OPENSALUD_ES_DOMAIN } from '@/constants/domains'

export default {
    name: 'gtag-iframe',
    computed: {
        inOpensaludES () {
            return window.location.host.includes(OPENSALUD_ES_DOMAIN)
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/utils/GtagIframe.vue